import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoIwsAssociatedViewClientState } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoIwsAssociatedViewClientState } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlAssociatedViewManagerResult extends IIsiDataTransferObject  {
    associatedViewManagerResult?: string;
}
export class IsiDtoPlAssociatedViewManagerResult extends IsiDataTransferObject implements IIsiDtoPlAssociatedViewManagerResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.AssociatedView.IsiDtoPlAssociatedViewManagerResult, Isilog.IsiComponent.IsiDataTransferObject";
    associatedViewManagerResult?: string;

    constructor(data?: IIsiDtoPlAssociatedViewManagerResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associatedViewManagerResult = _data["associatedViewManagerResult"] !== undefined ? _data["associatedViewManagerResult"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlAssociatedViewManagerResult): IsiDtoPlAssociatedViewManagerResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAssociatedViewManagerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["associatedViewManagerResult"] = this.associatedViewManagerResult !== undefined ? this.associatedViewManagerResult : <any>null;
        return data;
    }
}
export interface IIsiDtoPlAssociatedViewManagerResponse extends IIsiDtoPresentationLogicResponse  {
    clientStateResult?: IIsiDtoPlAssociatedViewManagerResult;
}
export class IsiDtoPlAssociatedViewManagerResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlAssociatedViewManagerResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.AssociatedView.IsiDtoPlAssociatedViewManagerResponse, Isilog.IsiComponent.IsiDataTransferObject";
    clientStateResult?: IsiDtoPlAssociatedViewManagerResult;

    constructor(data?: IIsiDtoPlAssociatedViewManagerResponse) {
        super(data);
        if (data) {
            this.clientStateResult = data.clientStateResult && !(<any>data.clientStateResult).toJSON ? new IsiDtoPlAssociatedViewManagerResult(data.clientStateResult) : <IsiDtoPlAssociatedViewManagerResult>this.clientStateResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientStateResult = _data["clientStateResult"] ? IsiDtoPlAssociatedViewManagerResult.fromJS(_data["clientStateResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlAssociatedViewManagerResponse): IsiDtoPlAssociatedViewManagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAssociatedViewManagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["clientStateResult"] = this.clientStateResult != null ? (<any>this.clientStateResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlAssociatedViewManagerRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlAssociatedViewManagerResponse;
    shownContextId?: string;
    updateXmlJoinRequest?: IIsiDtoPlAssociatedViewUpdateXmlJoinRequest;
    clientState?: IIsiDtoIwsAssociatedViewClientState;
}
export interface IIsiDtoPlAssociatedViewUpdateXmlJoinRequest extends IIsiDataTransferObject  {
    associatedViewContextId?: string;
    clientCtrlsValues?: { [key: string]: string; };
}
export class IsiDtoPlAssociatedViewUpdateXmlJoinRequest extends IsiDataTransferObject implements IIsiDtoPlAssociatedViewUpdateXmlJoinRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.AssociatedView.IsiDtoPlAssociatedViewUpdateXmlJoinRequest, Isilog.IsiComponent.IsiDataTransferObject";
    associatedViewContextId?: string;
    clientCtrlsValues?: { [key: string]: string; };

    constructor(data?: IIsiDtoPlAssociatedViewUpdateXmlJoinRequest) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associatedViewContextId = _data["associatedViewContextId"] !== undefined ? _data["associatedViewContextId"] : <any>null;
            this.clientCtrlsValues = _data["clientCtrlsValues"];
        }
    }

    static fromJS(data?: IIsiDtoPlAssociatedViewUpdateXmlJoinRequest): IsiDtoPlAssociatedViewUpdateXmlJoinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAssociatedViewUpdateXmlJoinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["associatedViewContextId"] = this.associatedViewContextId !== undefined ? this.associatedViewContextId : <any>null;
        data["clientCtrlsValues"] = this.clientCtrlsValues !== undefined ? this.clientCtrlsValues : <any>null;
        return data;
    }
}
export class IsiDtoPlAssociatedViewManagerRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlAssociatedViewManagerRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.AssociatedView.IsiDtoPlAssociatedViewManagerRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlAssociatedViewManagerResponse;
    shownContextId?: string;
    updateXmlJoinRequest?: IsiDtoPlAssociatedViewUpdateXmlJoinRequest;
    clientState?: IsiDtoIwsAssociatedViewClientState;

    constructor(data?: IIsiDtoPlAssociatedViewManagerRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlAssociatedViewManagerResponse(data.response) : <IsiDtoPlAssociatedViewManagerResponse>this.response;
            this.updateXmlJoinRequest = data.updateXmlJoinRequest && !(<any>data.updateXmlJoinRequest).toJSON ? new IsiDtoPlAssociatedViewUpdateXmlJoinRequest(data.updateXmlJoinRequest) : <IsiDtoPlAssociatedViewUpdateXmlJoinRequest>this.updateXmlJoinRequest;
            this.clientState = data.clientState && !(<any>data.clientState).toJSON ? new IsiDtoIwsAssociatedViewClientState(data.clientState) : <IsiDtoIwsAssociatedViewClientState>this.clientState;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlAssociatedViewManagerResponse.fromJS(_data["response"]) : <any>null;
            this.shownContextId = _data["shownContextId"] !== undefined ? _data["shownContextId"] : <any>null;
            this.updateXmlJoinRequest = _data["updateXmlJoinRequest"] ? IsiDtoPlAssociatedViewUpdateXmlJoinRequest.fromJS(_data["updateXmlJoinRequest"]) : <any>null;
            this.clientState = _data["clientState"] ? IsiDtoIwsAssociatedViewClientState.fromJS(_data["clientState"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlAssociatedViewManagerRequest): IsiDtoPlAssociatedViewManagerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlAssociatedViewManagerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["shownContextId"] = this.shownContextId !== undefined ? this.shownContextId : <any>null;
        data["updateXmlJoinRequest"] = this.updateXmlJoinRequest != null ? (<any>this.updateXmlJoinRequest).toJSON() : <any>null;
        data["clientState"] = this.clientState != null ? (<any>this.clientState).toJSON() : <any>null;
        return data;
    }
}
